module.exports = __webpack_public_path__ + "faroe-islands.svg?5548d2d083e6257a4a002fd1f1b18f75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/faroe-islands.svg
// module id = 164
// module chunks = 10